'use strict';
var dialog = require('./dialog'),
	util = require('./util');
var dialogTooltip = {
		events : function() {
			
			$("body").off('click', '.tooltip-click').on('click', '.tooltip-click', function(e) {
    	        e.preventDefault();
    	        var dialogClassName = 'tips';
    	        var windowHeight = $(window).height();
    	        if($(this).hasClass("coupon-tooltip-link")) {
    	        	dialogClassName += " coupon-tooltip";
    	        }
    	        if($(this).hasClass('terms-conditions-link')) { 
    	        	dialogClassName += " terms-and-conditions";
    	        }
    	        dialog.open({
    	            url: $(this).attr('href'),
    	            options: {
    	                dialogClass: dialogClassName,
    	                width: 330,
    	                height: 260,
    	                open: function() {
    	                	var $dialogContainer = $(this),
    	                		$curDialog = $dialogContainer.closest(".ui-dialog"),
    	                		$titleBar = $curDialog.find(".ui-dialog-titlebar");
    	                	
    	                	var dialogHeight = $curDialog.outerHeight(),
    	                		containerHeight = $curDialog.find('.tips-contents, .tips, .terms-scrollbar-height, .more').height(),
    	                		dialogWidth = 0, 
    	                		paddT = 0, 
    	                		paddB = 0, 
    	                		totalpadding = 0 ;
    	                	if($(window).width() >= 768) {
    		                    if (containerHeight > 260) {
		                            dialogHeight = 510;
		                            $curDialog.addClass('tooltip-dlg-ht-510');
		                        	containerHeight = $curDialog.find('.tips-contents, .tips, .terms-scrollbar-height, .more').height();
		                        	if(containerHeight > 510) {
		                        		dialogHeight = 600;
		                                dialogWidth = 428;
			                            $curDialog.addClass('tooltip-dlg-wt-428');
			                            if(containerHeight > 600) {
			                            	$curDialog.find('.tips-contents, .tips, .terms-scrollbar-height, .more').slimScroll({
			                                     height: "553px",
			                                     railVisible: true,
			                                     color: '#8f8f8f',
			                                     railColor: '#e9e9e9',
			                                     distance: '9px',
			                                     alwaysVisible: true
			                                 });
			                            }
			                            $curDialog.addClass('tooltip-dlg-ht-600');
		                        	}
			                    }
    	                	}
    	                	else if (containerHeight > windowHeight) {
    	                		dialogHeight = $(window).height(); 
    	                		dialogWidth = 320;
    	                		$curDialog.css({'height': dialogHeight + 'px'});	//We are calculating the device height to add to dialog.
    	                		$curDialog.addClass('tooltip-dlg-wt-mb-320');
    	                		if(containerHeight > parseInt(dialogHeight)) {
    	                			paddT = parseInt($curDialog.css('padding-top'));
    	                			paddB = parseInt($curDialog.css('padding-bottom'));
    	                			totalpadding = parseInt(paddT + paddB + 2);
    	                			dialogHeight = dialogHeight - totalpadding;
    	                			$curDialog.find('.tips-contents, .tips, .terms-scrollbar-height, .more').slimScroll({
    	                                height: dialogHeight,
    	                                railVisible: true,
    	                                color: '#8f8f8f',
    	                                railColor: '#e9e9e9',
    	                                distance: '9px',
    	                                alwaysVisible: true
    	                            });
    	                		}
    	                	}
    	                	$dialogContainer.addClass("make-height-auto");
    	                	
    	                    //** closing on overlay click **//
    	                    $('.ui-widget-overlay').on('click', function() {
    	                        if ($('.tips').is(':visible')) {
    	                            $('.tips').find('.ui-dialog-titlebar-close').trigger('click');   
    	                        }
    	                        var $dialogContainer = $(this),
    	                        	$curDialog = $dialogContainer.closest(".ui-dialog");
    	                        if($(window).width() >= 768) {
    	                        	$curDialog.removeClass('tooltip-dlg-ht-510');
    	                        	$curDialog.removeClass('tooltip-dlg-wt-428');
    	                        	$curDialog.removeClass('tooltip-dlg-ht-600');
    	                        }
    	                        else {
    	                        	$curDialog.removeClass('tooltip-dlg-wt-mb-320');
    	                        }
    	                    });
    	                    /** PXSFCC-4495_WCAG_Modal_focus_management **/
    	                    $(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter", function () {
    	                        $(this).focus();
    	                    });
    	                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
    	                },
                        close: function() {
                            var $dialogContainer = $(this),
                                $curDialog = $dialogContainer.closest(".ui-dialog");
                            if($(window).width() >= 768) {
                                $curDialog.removeClass('tooltip-dlg-ht-510');
                                $curDialog.removeClass('tooltip-dlg-wt-428');
                                $curDialog.removeClass('tooltip-dlg-ht-600');
                            }
                            else {
                                $curDialog.removeClass('tooltip-dlg-wt-mb-320');
                            }
                        }
    	            }
    	        });
    	    });
		}
}
module.exports = dialogTooltip;